export const StaticData = {
    fromServer: (data) => {
        return {
            key: data,
            value: data
        }
    }
}